// extracted by mini-css-extract-plugin
export default {"callout":"callout--xmeKG","header":"header--FT00u","title":"title--JEYNM","content":"content--mpNu7","variantWarning":"variantWarning--KeNRu"};